import { Component, OnInit, ChangeDetectionStrategy, HostBinding, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AsamcoUserService } from '@asamco/base';
import { pathJoin, showErrorSwal } from '@asamco/utils';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
    selector: 'al-marketplace-tile',
    templateUrl: './marketplace-tile.component.html',
    styleUrls: ['./marketplace-tile.component.scss', '../../styles/tile-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class MarketplaceTileComponent implements OnInit {
	@HostBinding('class') cssClasses = 'card custom-card add';

	public imgUrl = '';
	public isAdminSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private router: Router, private asamcoUserService: AsamcoUserService) {
		this.imgUrl = pathJoin([window['deployUrl'], '/assets/img/application-logos/applicationlinklink.png']);
		this.asamcoUserService.isAdmin().then(result => (this.isAdminSubject.next(result)));
	}

	@HostListener('click')
	onClick() {
		if(this.isAdminSubject.value)
		{
			this.router.navigateByUrl('application-link/marketplace');
		}
		else
		{
			Swal.fire({title: 'The marketplace is currently not available', text: 'Please contact support for more information', icon: 'info'})
		}
	}

	ngOnInit(): void {}
}
